export const environment = {};
import * as Parse from 'parse';
import { IParseConfiguration } from './common/services';
export { Parse };
export const parseConfig = {} as IParseConfiguration;
